// views/Categories.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";
import Table from "../../components/Table";
import ActionButtons from "../../components/ActionButtons";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import SearchBar from "../../components/SearchBar";
import LoadingOverlay from "../../components/LoadingOverlay";

function Categories() {
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await api.get("/categories");
      setCategories(res.data || []);
    } catch (error) {
      toast.error("Error al cargar categorías", "error");
    } finally {
      setLoading(false);
    }
  };

  const filteredCategories = categories.filter((category) =>
    `${category.name} ${category.description}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white p-6 rounded-xl shadow-md relative">
      <LoadingOverlay loading={loading} />
      <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
        <h2 className="text-3xl font-semibold text-gray-800">Categorías</h2>

        <div className="flex gap-3 items-center">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Link
            to="/categories/create"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow flex items-center gap-2 transition duration-300 whitespace-nowrap"
          >
            <Plus size={18} />
            <span>Nueva Categoría</span>
          </Link>
        </div>
      </div>

      <Table
        columns={[
          { label: "Nombre", key: "name", width: "w-1/2" },
          { label: "Descripción", key: "description", width: "w-1/2" },
        ]}
        data={filteredCategories}
        renderActions={(category) => (
          <ActionButtons
            editUrl={`/categories/edit/${category.id}`}
            onDelete={() => category.id}
          />
        )}
      />
    </div>
  );
}

export default Categories;
